import ApiService from './../api/ApiService';
import Config from '../constants/Config';
import ConfigPHS from '../models/ConfigPHS';
import Urls from './../api/Urls';

export function getConfigPHS() {
    return new ApiService({
        baseURL: Config.API_HOTEL,
        endpoint: Urls.CONFIG_PHS_INFO,
        parser: (data) => (data.data || []).map(item => new ConfigPHS(item))
    }).get();
}

export function updateConfigPHS(phs) {
    return new ApiService({
        baseURL: Config.API_HOTEL,
        endpoint: Urls.CONFIG_PHS_ACTION,
        parser: (data) => new ConfigPHS(data.phs),
    }).put(phs.export());
}
